"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "28", height: "33", viewBox: "0 0 28 33", className: "Icon toolbar-trash", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "defs",
            null,
            _react2.default.createElement(
                "filter",
                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "a-toolbar-trash" },
                _react2.default.createElement("feGaussianBlur", { stdDeviation: "1.383", "in": "SourceGraphic" })
            ),
            _react2.default.createElement(
                "linearGradient",
                { x1: "98.055%", y1: "50%", x2: "0%", y2: "50%", id: "b-toolbar-trash" },
                _react2.default.createElement("stop", { offset: "0%", stopColor: "#BEBEBE" }),
                _react2.default.createElement("stop", { offset: "27.774%", stopColor: "#DADADA" }),
                _react2.default.createElement("stop", { offset: "72.692%", stopColor: "#E2E2E2" }),
                _react2.default.createElement("stop", { offset: "100%", stopColor: "#D7D7D7" })
            ),
            _react2.default.createElement("path", { d: "M14.5 9c6.579 0 11.912-1.433 11.912-3.2 0-1.767-5.333-3.2-11.912-3.2-6.579 0-11.912 1.433-11.912 3.2C2.588 7.567 7.921 9 14.5 9z", id: "c-toolbar-trash" }),
            _react2.default.createElement(
                "filter",
                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "d-toolbar-trash" },
                _react2.default.createElement("feGaussianBlur", { stdDeviation: "1", "in": "SourceAlpha", result: "shadowBlurInner1" }),
                _react2.default.createElement("feOffset", { dy: "-2", "in": "shadowBlurInner1", result: "shadowOffsetInner1" }),
                _react2.default.createElement("feComposite", { "in": "shadowOffsetInner1", in2: "SourceAlpha", operator: "arithmetic", k2: "-1", k3: "1", result: "shadowInnerInner1" }),
                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.179093071 0", "in": "shadowInnerInner1" })
            ),
            _react2.default.createElement(
                "linearGradient",
                { x1: "98.055%", y1: "50%", x2: "0%", y2: "50%", id: "e-toolbar-trash" },
                _react2.default.createElement("stop", { offset: "0%", stopColor: "#BEBEBE" }),
                _react2.default.createElement("stop", { offset: "27.774%", stopColor: "#CDCDCD" }),
                _react2.default.createElement("stop", { offset: "72.692%", stopColor: "#DDD" }),
                _react2.default.createElement("stop", { offset: "100%", stopColor: "#C3C3C3" })
            ),
            _react2.default.createElement("path", { d: "M14 9c6.627 0 12-1.567 12-3.5S20.627 2 14 2 2 3.567 2 5.5 7.373 9 14 9z", id: "f-toolbar-trash" }),
            _react2.default.createElement(
                "filter",
                { x: "-50%", y: "-50%", width: "200%", height: "200%", filterUnits: "objectBoundingBox", id: "g-toolbar-trash" },
                _react2.default.createElement("feGaussianBlur", { stdDeviation: "1.5", "in": "SourceAlpha", result: "shadowBlurInner1" }),
                _react2.default.createElement("feOffset", { dy: "-2", "in": "shadowBlurInner1", result: "shadowOffsetInner1" }),
                _react2.default.createElement("feComposite", { "in": "shadowOffsetInner1", in2: "SourceAlpha", operator: "arithmetic", k2: "-1", k3: "1", result: "shadowInnerInner1" }),
                _react2.default.createElement("feColorMatrix", { values: "0 0 0 0 0.568627451 0 0 0 0 0.568627451 0 0 0 0 0.568627451 0 0 0 1 0", "in": "shadowInnerInner1" })
            )
        ),
        _react2.default.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M1.021 5.372C.628 3.385 5.741 1 14 1c8.26 0 13.372 2.385 12.979 4.372-.017.085-2.36 23.051-2.36 23.051C24.619 30.41 19.648 32 14 32S3.381 30.41 3.381 28.423c0 0-2.343-22.966-2.36-23.051z", fill: "#F8F8F8" }),
            _react2.default.createElement("path", { d: "M14 1.5c7.318 0 12.828 2.058 12.488 3.775-.012.064-.35 3.364-1.186 11.541l-.813 7.955-.266 2.61-.101.991C24.119 29.956 19.459 31.5 14 31.5S3.881 29.956 3.881 28.423c-.021-.23-.021-.23-.104-1.041l-.266-2.611-.81-7.925C1.864 8.64 1.525 5.34 1.512 5.275 1.172 3.558 6.683 1.5 14 1.5zM1.704 16.918l.812 7.954.266 2.611.102.99C2.88 30.808 7.99 32.5 14 32.5s11.119-1.693 11.119-4.077c.016-.13.016-.13.099-.94l.266-2.61a68575.266 68575.266 0 0 1 1.985-19.404C28.004 2.769 21.93.5 14 .5 6.072.5-.004 2.769.53 5.469c.003.01.547 5.319 1.174 11.449z", fill: "#A5A5A5", fillRule: "nonzero" }),
            _react2.default.createElement("path", { fill: "#FFF", filter: "url(#a-toolbar-trash)", d: "M20 31l3-23h-6z", fillOpacity: ".9" }),
            _react2.default.createElement(
                "g",
                null,
                _react2.default.createElement("use", { fill: "url(#b-toolbar-trash)", xlinkHref: "#c-toolbar-trash" }),
                _react2.default.createElement("use", { fill: "#000", filter: "url(#d-toolbar-trash)", xlinkHref: "#c-toolbar-trash" })
            ),
            _react2.default.createElement(
                "g",
                null,
                _react2.default.createElement("use", { fill: "url(#e-toolbar-trash)", xlinkHref: "#f-toolbar-trash" }),
                _react2.default.createElement("use", { fill: "#000", filter: "url(#g-toolbar-trash)", xlinkHref: "#f-toolbar-trash" })
            ),
            _react2.default.createElement("path", { d: "M14 9.5c6.925 0 12.5-1.626 12.5-4s-5.575-4-12.5-4-12.5 1.626-12.5 4 5.575 4 12.5 4zm0-1c-6.33 0-11.5-1.508-11.5-3s5.17-3 11.5-3 11.5 1.508 11.5 3-5.17 3-11.5 3z", fill: "#FFF", fillRule: "nonzero" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/toolbar-trash.js
// module id = 1897
// module chunks = 0